import { Component } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { CptGoogleTagmanagerService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { SharedService } from '../../../../services/shared.service'

import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
@Component({
  selector: 'customer-portal-app-revolution-vehicle-online-shop-link',
  standalone: true,
  templateUrl: './vehicle-online-shop-link.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class VehicleOnlineShopLinkComponent {
  constructor (
    public dialog: MatDialog,
    public sharedService: SharedService,
    private readonly cptGtmService: CptGoogleTagmanagerService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.link = this.remoteConfigService.get('shopLink')
  }

  link

  sendContentModulesCTAData (contentModuleLabel: string): void {
    this.cptGtmService.sendContentModulesData(
      'CTA',
      'Click',
      this.sharedService.translateLink(contentModuleLabel) ?? '',
      'CTA',
      this.sharedService.translateLink(contentModuleLabel) ?? ''
    )
  }
}
